import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { loginByPassword, SaveDevice } from "../Service/Auth-Services";
import { useHistory } from "react-router-dom";
import LoginLoader from "../../../Shared/Sidebar/LoginLoader";
import { useDataContext } from "../../../Services/Context-Api/Context";
import TosterService from "../../../Services/Toster-Service/TosterService";
import {
  GetMasterSystemAlert,
  menuDynamicFunctionality,
  NotificationCount,
} from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

export default function LoginByPassword() {
  const { apiData } = useDataContext();
  const [classname, setClassname] = useState("fa fa-eye");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [browserInfo, setBrowserInfo] = useState({ name: "", version: "" });
  const [errorMessage, setErrorMessage] = useState(false ?? "");
  const [password_Validation_Header, setPassword_Validation_Header] = useState('')
  let history = useHistory();
  const toster = useRef(null);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  if (!apiData) {
    history.push("otp");
  }

  const LoginValidation = Yup.object().shape({
    password: Yup.string().required("Password is mandatory."),
  });
  const LoginForm = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: LoginValidation,
    onSubmit: async (data) => {
      const localDate = new Date();
      const utcString = localDate.toISOString();
      setLoader(true);
      data.username = apiData?.customer?.UserName;
      data.isEncrypted = false;
      data.TimeZone = utcString;
      try {
        let Request = await loginByPassword(data);
        let currentTime = new Date();
        Request.Data.Authentication.expires_in = new Date(
          currentTime.setMinutes(
            currentTime.getMinutes() +
            Request.Data.Authentication.expires_in / 60
          )
        );
        localStorage.setItem(
          "Authentication",
          JSON.stringify(Request.Data.Authentication)
        );
        localStorage.setItem(
          "Permissions",
          JSON.stringify(Request.Data.Permissions)
        );
        localStorage.setItem("Roles", JSON.stringify(Request.Data.Roles));
        localStorage.setItem("User", JSON.stringify(Request.Data.User));
        localStorage.setItem("LanguageKey", JSON.stringify("English"));
        localStorage.setItem("AppVersion", JSON.stringify(Request?.Data?.User?.AppVersions?.find((el) => el?.Type == "Mobile")));
        window.dispatchEvent(new Event('authStateChanged'));
        MenuDynamicFunctionality(Request?.Data);
        setTimeout(() => {
          GetMasterSystemAfterLoginAlertList();
        });
      } catch (err) {
        setLoader(false);
        GetMasterSystemAlertList("Incorrect_Password", 1);
      }
    },
  });

  async function MenuDynamicFunctionality(userDetails) {
    var params = {
      OrgId: userDetails?.User?.OrgId,
      loggedInEmpId: userDetails?.User?.EmpId,
      WebOrMobile: 1,
    };
    try {
      const data = await menuDynamicFunctionality(params);
      localStorage.setItem("DynamicMenuJson", JSON.stringify(data.Data));
      postSaveDevice(userDetails);
      notificationCount(userDetails);
    } catch (error) {
      toster.current.error(ERROR_LIST?.DynamicMenu);
    }
  }

  async function notificationCount(userDetails) {
    var params = {
      EmpId: userDetails?.User?.EmpId,
    };
    try {
      const data = await NotificationCount(params);
      setLoader(false);
      localStorage.setItem(
        "NotificationCount",
        JSON.stringify(data?.Data[0]?.UnreadNotifications)
      );
      history.push("/Dashboard");
    } catch (error) {
      toster.current.error(ERROR_LIST?.NotificationError);
    }
  }

  function ViewPassword() {
    let pwd = document.getElementById("viewPassword");
    if (pwd.type === "password") {
      pwd.type = "text";
      classname = 'fa fa-eye-slash';
    } else {
      pwd.type = "password";
      classname = 'classname';
    }
  }

  function ViewPassword() {
    const pwd = document.getElementById("viewPassword");
    if (!showPassword) {
      pwd.type = "text";
      setClassname("fa fa-eye-slash");
    } else {
      pwd.type = "password";
      setClassname("fa fa-eye");
    }

    setShowPassword(!showPassword);
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setErrorMessage(msg?.Desc);
      } else if (msg?.Name == message && type == 3) {
        setPassword_Validation_Header(msg?.Desc);
      }
    });
  }, []);
  useEffect(() => {
    GetMasterSystemAlertList('Password_Validation_Header', 3)
    const userAgent = navigator.userAgent;
    let name = "Unknown";
    let version = "Unknown";

    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      name = "Chrome";
      version = userAgent.match(/Chrome\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Firefox")) {
      name = "Firefox";
      version = userAgent.match(/Firefox\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      name = "Safari";
      version = userAgent.match(/Version\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("Edg")) {
      name = "Edge";
      version = userAgent.match(/Edg\/([\d.]+)/)?.[1] || "Unknown";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
      name = "Internet Explorer";
      version = userAgent.match(/(?:MSIE |rv:)([\d.]+)/)?.[1] || "Unknown";
    }
    setBrowserInfo({ name, version });
    const handleBackButton = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  const GetMasterSystemAfterLoginAlertList = useCallback(async () => {
    const body = {
      Name: "",
    };
    try {
      let MasterSystemAlert = await GetMasterSystemAlert(body);
      localStorage?.setItem(
        "SystemAlerts",
        JSON?.stringify(MasterSystemAlert?.Data)
      );
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoader(false);
    }
  }, []);

  async function postSaveDevice(userDetails) {
    const now = new Date();
    let appVersion = userDetails?.AppVersions?.find(
      (el) => el?.Type == "Web"
    )?.NewVersion;
    var params = {
      EmpId: userDetails?.EmpId,
      Device: browserInfo?.name,
      Desc: browserInfo?.version,
      AppVersion: String(appVersion),
      TimeZone: now.toUTCString(),
    };
    try {
      await SaveDevice(params);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  return (
    <section className="fxt-template-animation fxt-template-layout29 loaded">
      <div className="login-org-logo-area">
        <div className="container">
          <a className="fxt-logo">
            <img
              src="images/login/logo.png"
              alt="Logo"
              className="logo-login"
            />
          </a>
        </div>
      </div>
      <img src="images/login/right.png" className="leftpic" />
      <img src="  images/login/left.png" className="rightpic" />
      <div className="login-org-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="fxt-content otp-screen-area">

                <div className="fxt-form">

                  <div className="fxt-transformY-50 fxt-transition-delay-1">
                    <h2>{password_Validation_Header}</h2>
                    <div class="otp-company-name"><h2>{apiData?.customer?.OrganizationName}</h2></div>

                  </div>
                  <div style={{ textAlign: 'center' }}>
                  </div>
                  <div className="fxt-transformY-50 fxt-transition-delay-2">
                    <div className="formdivv ">
                      <Link to="/">
                        {apiData?.customer?.UserName}
                        <i className="fa fa-pencil p-2"></i>{" "}
                      </Link>
                    </div>
                  </div>

                  <form onSubmit={LoginForm.handleSubmit}>
                    <div className="form-group">
                      <div className="fxt-transformY-50 fxt-transition-delay-4">
                        <input
                          type="password"
                          name="password"
                          id="viewPassword"
                          className={
                            "form-control" +
                            (LoginForm.errors.password &&
                              LoginForm.touched.password
                              ? " is-invalid"
                              : "")
                          }
                          onChange={(e) => {
                            LoginForm.handleChange(e);
                            setErrorMessage("");
                          }}
                          value={LoginForm.values.password}
                          placeholder="Password"
                          style={{ backgroundImage: "none" }}
                        />
                        <div className="sign-in-icon">
                          <i onClick={ViewPassword} className={classname}></i>
                        </div>
                      </div>
                      {errorMessage && (
                        <div className="invalid-feedback">{errorMessage}</div>
                      )}
                      <div className="invalid-feedback">
                        {LoginForm.errors.password && LoginForm.touched.password
                          ? LoginForm.errors.password
                          : null}
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="fxt-transformY-50 fxt-transition-delay-6">
                        <div className="fxt-content-between">
                          <button type="submit" className="fxt-btn-fill">
                            {loader ? <LoginLoader /> : ""} Log in
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div>
                    <Link to="/" className="pass-login login-password">
                      Back To Login
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="vegas-container col-lg-6 col-md-6">
              <div className="">
                <img src="/images/login/signup.svg" className="img-fluid" />
              </div>
            </div>

          </div>
        </div>
      </div>
      <TosterService ref={toster} />
    </section>
  );
}
